// 智慧考勤
import Log from '../view/log'
import WorkAttendanceNav from '../view/WorkAttendance/WorkAttendanceNav'
import AttendanceDepartmentManage from '../view/WorkAttendance/AttendanceDepartment/AttendanceDepartmentManage'
import AttendanceDepartmentAdd from '../view/WorkAttendance/AttendanceDepartment/AttendanceDepartmentAdd'
import AttendanceDepartmentModify from '../view/WorkAttendance/AttendanceDepartment/AttendanceDepartmentModify'
import AttendancePositionManage from '../view/WorkAttendance/AttendancePosition/AttendancePositionManage'
import AttendancePositionAdd from '../view/WorkAttendance/AttendancePosition/AttendancePositionAdd'
import AttendancePositionModify from '../view/WorkAttendance/AttendancePosition/AttendancePositionModify'
import AttendancePersonManage from '../view/WorkAttendance/AttendancePerson/AttendancePersonManage'
import AttendancePersonAdd from '../view/WorkAttendance/AttendancePerson/AttendancePersonAdd'
import AttendancePersonModify from '../view/WorkAttendance/AttendancePerson/AttendancePersonModify'
import AttendanceOvertimeManage from '../view/WorkAttendance/AttendanceOvertime/AttendanceOvertimeManage'
import AttendanceOvertimeAdd from '../view/WorkAttendance/AttendanceOvertime/AttendanceOvertimeAdd'
import AttendanceOvertimeModify from '../view/WorkAttendance/AttendanceOvertime/AttendanceOvertimeModify'
import AttendancePointManage from '../view/WorkAttendance/AttendancePoint/AttendancePointManage'
import AttendancePointAdd from '../view/WorkAttendance/AttendancePoint/AttendancePointAdd'
import AttendancePointModify from '../view/WorkAttendance/AttendancePoint/AttendancePointModify'
import AttendanceTeamManage from '../view/WorkAttendance/AttendanceTeam/AttendanceTeamManage'
import AttendanceTeamAdd from '../view/WorkAttendance/AttendanceTeam/AttendanceTeamAdd'
import AttendanceTeamModify from '../view/WorkAttendance/AttendanceTeam/AttendanceTeamModify'
import AttendanceFrequencyManage from '../view/WorkAttendance/AttendanceFrequency/AttendanceFrequencyManage'
import AttendanceFrequencyAdd from '../view/WorkAttendance/AttendanceFrequency/AttendanceFrequencyAdd'
import AttendanceFrequencyModify from '../view/WorkAttendance/AttendanceFrequency/AttendanceFrequencyModify'
import AttendanceSchedulingManage from '../view/WorkAttendance/AttendanceScheduling/AttendanceSchedulingManage'
import AttendanceSchedulingAdd from '../view/WorkAttendance/AttendanceScheduling/AttendanceSchedulingAdd'
import AttendanceSchedulingRank from '../view/WorkAttendance/AttendanceScheduling/AttendanceSchedulingRank'
import AttendanceSchedulingRankDetail from '../view/WorkAttendance/AttendanceScheduling/AttendanceSchedulingRankDetail'
import AttendanceSwitchManage from '../view/WorkAttendance/AttendanceSwitch/AttendanceSwitchManage'
import AttendanceSwitchAdd from '../view/WorkAttendance/AttendanceSwitch/AttendanceSwitchAdd'
import AttendanceSwitchModify from '../view/WorkAttendance/AttendanceSwitch/AttendanceSwitchModify'
import AttendanceOvertimeApplicationManage from '../view/WorkAttendance/AttendanceOvertimeApplication/AttendanceOvertimeApplicationManage'
import AttendanceOvertimeApplicationAdd from '../view/WorkAttendance/AttendanceOvertimeApplication/AttendanceOvertimeApplicationAdd'
import AttendanceOvertimeApplicationModify from '../view/WorkAttendance/AttendanceOvertimeApplication/AttendanceOvertimeApplicationModify'
import AttendanceRepairApplicationManage from '../view/WorkAttendance/AttendanceRepairApplication/AttendanceRepairApplicationManage'
import AttendanceRepairApplicationAdd from '../view/WorkAttendance/AttendanceRepairApplication/AttendanceRepairApplicationAdd'
import AttendanceRepairApplicationModify from '../view/WorkAttendance/AttendanceRepairApplication/AttendanceRepairApplicationModify'
import AttendanceAdjustManage from '../view/WorkAttendance/AttendanceAdjust/AttendanceAdjustManage'
import AttendanceAdjustAdd from '../view/WorkAttendance/AttendanceAdjust/AttendanceAdjustAdd'
import AttendanceAdjustModify from '../view/WorkAttendance/AttendanceAdjust/AttendanceAdjustModify'
import AttendanceVacationManage from '../view/WorkAttendance/AttendanceVacation/AttendanceVacationManage'
import AttendanceVacationAdd from '../view/WorkAttendance/AttendanceVacation/AttendanceVacationAdd'
import AttendanceVacationModify from '../view/WorkAttendance/AttendanceVacation/AttendanceVacationModify'
import AttendancepPunchRecordManage from '../view/WorkAttendance/AttendancePunchRecordManage/AttendancepPunchRecordManage'
import AttendanceRecordManage from '../view/WorkAttendance/AttendanceRecord/AttendanceRecordManage'
import AttendanceReportManage from '../view/WorkAttendance/AttendanceReport/AttendanceReportManage'
import AttendanceSalaryReport from '../view/WorkAttendance/AttendanceSalaryReport/AttendanceSalaryReport'
import AttendanceConfig from '../view/WorkAttendance/AttendanceConfig/AttendanceConfig'

export default [
  /* 智慧考勤 */
  {
    path: '/attendance_department_manage',
    name: 'attendance-department-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceDepartmentManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_department_add',
    name: 'attendance-department-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceDepartmentAdd
    }
  },
  {
    path: '/attendance_department_modify/:id',
    name: 'attendance-department-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceDepartmentModify
    }
  },
  {
    path: '/attendance_position_manage',
    name: 'attendance-position-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendancePositionManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_position_add',
    name: 'attendance-position-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendancePositionAdd
    }
  },
  {
    path: '/attendance_position_modify/:id',
    name: 'attendance-position-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendancePositionModify
    }
  },
  {
    path: '/attendance_person_manage',
    name: 'attendance-person-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendancePersonManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_person_add',
    name: 'attendance-person-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendancePersonAdd
    }
  },
  {
    path: '/attendance_person_modify/:id',
    name: 'attendance-person-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendancePersonModify
    }
  },
  {
    path: '/attendance_overtime_manage',
    name: 'attendance-overtime-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceOvertimeManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_overtime_add',
    name: 'attendance-overtime-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceOvertimeAdd
    }
  },
  {
    path: '/attendance_overtime_modify/:id',
    name: 'attendance-overtime-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceOvertimeModify
    }
  },
  {
    path: '/attendance_point_manage',
    name: 'attendance-point-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendancePointManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_point_add',
    name: 'attendance-point-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendancePointAdd
    }
  },
  {
    path: '/attendance_point_modify/:id',
    name: 'attendance-point-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendancePointModify
    }
  },
  {
    path: '/attendance_team_manage',
    name: 'attendance-team-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceTeamManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_team_add',
    name: 'attendance-team-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceTeamAdd
    }
  },
  {
    path: '/attendance_team_modify/:id',
    name: 'attendance-team-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceTeamModify
    }
  },
  {
    path: '/attendance_frequency_manage',
    name: 'attendance-frequency-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceFrequencyManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_frequency_add',
    name: 'attendance-frequency-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceFrequencyAdd
    }
  },
  {
    path: '/attendance_frequency_modify/:id',
    name: 'attendance-frequency-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceFrequencyModify
    }
  },
  {
    path: '/attendance_scheduling_manage',
    name: 'attendance-scheduling-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceSchedulingManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_scheduling_add',
    name: 'attendance-scheduling-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceSchedulingAdd
    }
  },
  {
    path: '/attendance_scheduling_rank/:id',
    name: 'attendance-scheduling-rank',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceSchedulingRank
    }
  },
  {
    path: '/attendance_scheduling_rank_detail',
    name: 'attendance-scheduling-rank-detail',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceSchedulingRankDetail
    }
  },
  {
    path: '/attendance_switch_manage',
    name: 'attendance-switch-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceSwitchManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_switch_add',
    name: 'attendance-switch-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceSwitchAdd
    }
  },
  {
    path: '/attendance_switch_modify/:id',
    name: 'attendance-switch-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceSwitchModify
    }
  },
  {
    path: '/attendance_overtime_application_manage',
    name: 'attendance-overtime-application-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceOvertimeApplicationManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_overtime_application_add',
    name: 'attendance-overtime-application-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceOvertimeApplicationAdd
    }
  },
  {
    path: '/attendance_overtime_application_modify/:id',
    name: 'attendance-overtime-application-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceOvertimeApplicationModify
    }
  },
  {
    path: '/attendance_repair_application_manage',
    name: 'attendance-repair-application-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceRepairApplicationManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_repair_application_add',
    name: 'attendance-repair-application-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceRepairApplicationAdd
    }
  },
  {
    path: '/attendance_repair_application_modify/:id',
    name: 'attendance-repair-application-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceRepairApplicationModify
    }
  },
  {
    path: '/attendance_adjust_manage',
    name: 'attendance-adjust-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceAdjustManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_adjust_add',
    name: 'attendance-adjust-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceAdjustAdd
    }
  },
  {
    path: '/attendance_adjust_modify/:id',
    name: 'attendance-adjust-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceAdjustModify
    }
  },
  {
    path: '/attendance_vacation_manage',
    name: 'attendance-vacation-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceVacationManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_vacation_add',
    name: 'attendance-vacation-add',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceVacationAdd
    }
  },
  {
    path: '/attendance_vacation_modify/:id',
    name: 'attendance-vacation-modify',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceVacationModify
    }
  },
  {
    path: '/attendance_record_manage',
    name: 'attendance-record-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceRecordManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_punch_record_manage',
    name: 'attendance-punch-record-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendancepPunchRecordManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_report_manage',
    name: 'attendance-report-manage',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceReportManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_salary_report',
    name: 'attendance-salary-report',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceSalaryReport
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/attendance_config',
    name: 'attendance-config',
    components: {
      default: WorkAttendanceNav,
      a: AttendanceConfig
    }
  },
  /* 智慧考勤 */

  // 考勤操作日志
  {
    path: '/work_attendance_log',
    name: 'work-attendance-log',
    components: {
      default: WorkAttendanceNav,
      a: Log
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/WorkAttendance.js